export const C_IMMOVABLE_STATUS = {
  unused: {
    name: "Nuevo",
    id: "unused"
  },
  used: {
    name: "Usado",
    id: "used"
  }
};

export const A_IMMOVABLE_STATUS = [
  C_IMMOVABLE_STATUS.used,
  C_IMMOVABLE_STATUS.unused
];
